import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-item-box',
  imports: [CommonModule],
  template: `
    <div class="group flex items-center gap-2">
      @if (showArrow === 'left') {
        <i class="pi pi-chevron-left text-zinc-500 group-hover:text-black"></i>
      }
      <div class="flex-1 overflow-hidden">
        <ng-content></ng-content>
      </div>
      @if (showArrow === 'right') {
        <i class="pi pi-chevron-right text-zinc-500 group-hover:text-black"></i>
      }
    </div>
  `,
  standalone: true,
  host: {
    class: 'block rounded-lg px-4 py-2 border border-zinc-100 bg-gray-50',
  },
})
export class ItemBoxComponent {
  @Input() showArrow: 'left' | 'right' | 'none' = 'none';
  @Input() isButton = false;

  @HostBinding('attr.role')
  get role() {
    return this.isButton ? 'button' : null;
  }
}
